var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIconOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "package",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.996,
    height: 21,
    viewBox: "0 0 18.996 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2699",
    "data-name": "Group 2699"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M16.147,10a.816.816,0,0,1-.409-.11l-8.679-5a.82.82,0,0,1,.819-1.42l8.678,5a.82.82,0,0,1-.41,1.53Z",
    transform: "translate(-2.311 -1.231)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M11.648,22.073a2.752,2.752,0,0,1-1.374-.368L3.527,17.849A2.758,2.758,0,0,1,2.15,15.47V7.755A2.757,2.757,0,0,1,3.524,5.377l6.753-3.859a2.748,2.748,0,0,1,2.745,0l6.747,3.855a2.758,2.758,0,0,1,1.377,2.379V15.47a2.757,2.757,0,0,1-1.374,2.378l-6.753,3.859A2.748,2.748,0,0,1,11.648,22.073Zm0-19.282a1.11,1.11,0,0,0-.554.149L4.341,6.8a1.111,1.111,0,0,0-.551.957V15.47a1.112,1.112,0,0,0,.554.958l6.747,3.855a1.109,1.109,0,0,0,1.112,0l6.753-3.859a1.111,1.111,0,0,0,.551-.957V7.755a1.112,1.112,0,0,0-.554-.958L12.206,2.942A1.114,1.114,0,0,0,11.648,2.791Z",
    transform: "translate(-2.15 -1.152)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M11.658,12.619a.819.819,0,0,1-.41-.11L2.829,7.639A.82.82,0,1,1,3.65,6.22l8.008,4.632L19.666,6.22a.82.82,0,1,1,.821,1.419l-8.418,4.87A.819.819,0,0,1,11.658,12.619Z",
    transform: "translate(-2.16 -1.329)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M11.97,22.509a.82.82,0,0,1-.82-.82V11.97a.82.82,0,1,1,1.639,0v9.72A.82.82,0,0,1,11.97,22.509Z",
    transform: "translate(-2.471 -1.509)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIconOrder);
export default __webpack_public_path__ + "static/media/product-icon-order.20a4edde7be64c6f28a3b576848ef052.svg";
export { ForwardRef as ReactComponent };